module.exports = __webpack_public_path__ + "img/verifier.0f72fdf7.svg";